import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useWeb3React, useWeb3 } from 'web3/hooks';
import { Header, View, Text, ErrorBox, WarningBox } from 'modules/styled';
import { useSignAddress } from 'modules/auth/web3.hooks';
import ProfileForm from './profile.form';

SignupMM.propTypes = {
  close: PropTypes.func,
};

export default function SignupMM({ close }) {
  useWeb3();
  const [[sigError, sig, msg], setSig] = useState([]);
  const { account, metamask } = useWeb3React();

  useEffect(() => {
    if (account) setSig([]);
  }, [account]);

  useSignAddress(account, metamask, setSig);

  const initialValues = {};

  const additionalFields = sig && {
    signature: sig,
    ethLogin: account,
    msg: msg,
  };

  return (
    <Fragment>
      <Header sx={{ mb: 2 }}>Sign up with Metamask</Header>
      {account && !sig && <Text sx={{ mt: 1 }}>Address: {account}</Text>}
      {!sig && (
        <WarningBox sx={{ mt: 4 }}>
          <Text>Please sign the authorization message using Metamask</Text>
        </WarningBox>
      )}
      {sigError && (
        <ErrorBox sx={{ mt: 4 }}>
          <Text>{sigError}</Text>
        </ErrorBox>
      )}
      <View sx={{ mt: 2 }} />
      {account && sig && (
        <ProfileForm
          initialValues={initialValues}
          additionalFields={additionalFields}
          close={close}
        />
      )}
    </Fragment>
  );
}
